"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderNutrients = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const changeOrderInNutritionFacts_1 = __importDefault(require("./changeOrderInNutritionFacts"));
const typography_1 = require("../../shared/typography");
const assembleValue = (key, value, unit) => {
    if (key === "calories")
        return value + "";
    return `${value} ${unit}`;
};
const renderNutrientFacts = (nutritionFacts, unit) => {
    const JSX = [];
    const orderedNutritionFacts = (0, changeOrderInNutritionFacts_1.default)(nutritionFacts);
    for (const key in orderedNutritionFacts) {
        JSX.push((0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(typography_1.P, { children: assembleValue(key, nutritionFacts[key], unit) }, void 0) }, void 0) }, key));
    }
    return JSX;
};
const renderNutrients = (unit, isMealPlan) => (nutrient, index) => {
    return ((0, jsx_runtime_1.jsxs)(NutrientWrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [!isMealPlan && ((0, jsx_runtime_1.jsx)(typography_1.P, { className: "unit", children: `${nutrient.measure.value} ${unit}` }, void 0)), (0, jsx_runtime_1.jsx)(typography_1.P, { children: nutrient.name }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", { children: renderNutrientFacts(nutrient.nutritionFacts, unit) }, void 0)] }, nutrient.name + index));
};
exports.renderNutrients = renderNutrients;
const NutrientWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacings.xs} 0`};

  p {
    margin-bottom: 0;
  }

  & > div:first-of-type {
    display: flex;
    flex: 2;
  }

  & > div:first-of-type p:first-of-type {
    flex: 1;
  }

  & > div:first-of-type p:last-of-type {
    flex: 3;
    word-break: break-word;
    word-wrap: break-spaces;
  }

  & > div:last-of-type {
    flex: 3;
    margin-right: ${({ theme }) => theme.spacings.l};
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
  }

  & > div:last-of-type p {
    color: ${({ theme }) => theme.colors.greyBase};
    font-size: 1rem;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:last-of-type {
      flex: 7;
      margin-right: 0;
    }

    & > div:first-of-type p.unit {
      display: none;
    }
  }
`;
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex: 1;
  justify-content: flex-start;

  & > div {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  p {
    color: ${({ theme }) => theme.colors.greyLighten40};
    font-size: 0.875rem;
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=renderNutrientFacts.js.map